// -----------------------------------------------------------------------------
// Scripts for sticky submenu
// -----------------------------------------------------------------------------

function stickySubmenu() {

  var subMenu = $('.child-pages');
  var subMenuHeight = $('.child-pages').outerHeight();
  var header = $('.header').outerHeight();


  if (($('.subpage-header').length == 0) && (subMenu.length > 0)) {

    $('body').css('padding-top', (subMenuHeight + header));
    subMenu.addClass('child-pages--sticky');
    subMenu.css('top', header);

  }
}